import { forwardRef } from "react";

import Autocomplete from "./Autocomplete";
import InputWrapper from "./InputWrapper";

const formatPatient = patient => {
  if (!patient) {
    return null;
  }
  let user = patient.patientProfile.user;
  return `${user.firstName} ${user.lastName} (${user.correspondenceEmail})`;
};

function SelectPatient({ patients, value, onChange, disabled }) {
  const list = patients || [];
  const options = list.map(patient => ({
    label: formatPatient(patient),
    value: String(patient.id)
  }));

  return (
    list.length > 0 && (
      <Autocomplete
        options={options}
        placeholder="Select patient"
        value={value != null && value !== "" ? String(value) : ""}
        onChange={onChange}
        maxWidth={310}
        noOptionsFoundMessage="No patients found"
        disabled={disabled}
      />
    )
  );
}

const SelectPatientField = forwardRef(
  ({ label, labelProps, error, patients, value, onChange, disabled, ...props }, ref) => (
    <InputWrapper
      labelProps={labelProps}
      label={label}
      error={error}
      input={
        <SelectPatient patients={patients} value={value} onChange={onChange} disabled={disabled} />
      }
      {...props}
    />
  )
);

export default SelectPatientField;
